/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-14 21:56:36
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragRowDisplay/DoubleRowsTextAndEditIcon/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

import EditDeleteIconContainer from '../EditDeleteIconContainer';
const TextAndEditIcon = (props) => {
  const {
    disabled,
    name,
    onClick,
    additional,
    containerClassName,
    onDelete,
    title,
  } = props;
  return (
    <EditDeleteIconContainer
      frontPart={
        <React.Fragment>
          <div className={css.titleContainer}>{title}</div>

          <div className={css.sku}>
            <NoWrapContainer>
              <GlobalTooltip title={name}>{name}</GlobalTooltip>
            </NoWrapContainer>
          </div>
        </React.Fragment>
      }
      disabled={disabled}
      onClick={onClick}
      onDelete={onDelete}
      containerClassName={`${css.containerClassName} ${
        containerClassName || ''
      }`}
      additional={additional}
    />
  );
};
export default TextAndEditIcon;
